class PostStackorder {
    constructor(postStackorder) {
        Object.assign(this, postStackorder, {});
    }
    static constructFrom(stackorder) {
        const constructedStackorder = {
            name: stackorder.name,
            from: stackorder.from,
            to: stackorder.to,
            tariffIds: stackorder.tariffIds,
            type: stackorder.type,
            hourLimit: stackorder.hourLimit,
        };
        return new PostStackorder(constructedStackorder);
    }
}
export default PostStackorder;
